/* CILSY · Product Pro — vanilla JS, no deps */
(function(){
  function ready(fn){document.readyState!='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-cyp]').forEach(initSection);
  });

  function initSection(root){
    /* Gallery */
    var slides=root.querySelectorAll('[data-cyp-slide]');
    var thumbs=root.querySelectorAll('[data-cyp-thumb]');
    function go(i){
      if(i<0)i=slides.length-1; if(i>=slides.length)i=0;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i)});
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
    var prev=root.querySelector('[data-cyp-prev]'); var next=root.querySelector('[data-cyp-next]');
    var cur=function(){var a=0;slides.forEach(function(s,k){if(s.classList.contains('is-active'))a=k});return a};
    if(prev)prev.addEventListener('click',function(){go(cur()-1)});
    if(next)next.addEventListener('click',function(){go(cur()+1)});

    /* Variants */
    var form=root.querySelector('[data-cyp-form]');
    var variantInput=root.querySelector('[data-cyp-variant-id]');
    var btnText=root.querySelector('[data-cyp-cta-text]');
    var btn=root.querySelector('[data-cyp-cta]');
    var priceCurrent=root.querySelector('[data-cyp-price-current]');
    var priceCompare=root.querySelector('[data-cyp-price-compare]');
    var ctaCurrent=root.querySelector('[data-cyp-cta-price]');
    var ctaCompare=root.querySelector('[data-cyp-cta-compare]');
    var variants=[];
    try{variants=JSON.parse(root.querySelector('[data-cyp-variants]').textContent);}catch(e){}
    function fmt(cents){try{return (Shopify&&Shopify.formatMoney?Shopify.formatMoney(cents,window.cypMoneyFormat||'€{{amount}}'):'€'+(cents/100).toFixed(2));}catch(e){return '€'+(cents/100).toFixed(2)}}
    function setVariant(v){
      if(!v)return;
      if(variantInput)variantInput.value=v.id;
      if(priceCurrent)priceCurrent.textContent=fmt(v.price);
      if(ctaCurrent)ctaCurrent.textContent=fmt(v.price);
      if(priceCompare){
        if(v.compare_at_price&&v.compare_at_price>v.price){priceCompare.textContent=fmt(v.compare_at_price);priceCompare.style.display='';}
        else priceCompare.style.display='none';
      }
      if(ctaCompare){
        if(v.compare_at_price&&v.compare_at_price>v.price){ctaCompare.textContent=fmt(v.compare_at_price);ctaCompare.style.display='';}
        else ctaCompare.style.display='none';
      }
      if(btn){
        btn.disabled=!v.available;
        if(btnText)btnText.textContent=v.available?(btn.dataset.labelAdd||'Toevoegen aan tas'):(btn.dataset.labelOos||'Uitverkocht');
      }
    }
    root.querySelectorAll('[data-cyp-option]').forEach(function(group){
      var name=group.dataset.cypOption;
      group.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(){
          group.querySelectorAll('button').forEach(function(x){x.classList.remove('is-active')});
          b.classList.add('is-active');
          var sel={};
          root.querySelectorAll('[data-cyp-option]').forEach(function(g){
            var act=g.querySelector('button.is-active'); if(act)sel[g.dataset.cypOption]=act.dataset.value;
          });
          var match=variants.find(function(v){return Object.keys(sel).every(function(k){return v.options_map[k]===sel[k]})});
          if(match)setVariant(match);
        });
      });
    });

    /* Qty */
    var qty=root.querySelector('[data-cyp-qty]');
    if(qty){
      root.querySelectorAll('[data-cyp-qty-btn]').forEach(function(b){
        b.addEventListener('click',function(){
          var d=parseInt(b.dataset.cypQtyBtn,10)||0;
          qty.value=Math.max(1,(parseInt(qty.value,10)||1)+d);
        });
      });
    }

    /* Addon toggles */
    root.querySelectorAll('[data-cyp-addon]').forEach(function(el){
      el.addEventListener('click',function(){
        if(el.dataset.soldOut==='true')return;
        el.classList.toggle('is-on');
        var input=el.querySelector('input[type="hidden"]');
        if(input)input.disabled=!el.classList.contains('is-on');
      });
    });

    /* Add-to-cart submit (AJAX) */
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var fd=new FormData(form);
        var items=[{id:fd.get('id'),quantity:parseInt(fd.get('quantity'),10)||1}];
        root.querySelectorAll('[data-cyp-addon].is-on input[type="hidden"]:not([disabled])').forEach(function(i){
          items.push({id:i.value,quantity:1});
        });
        if(btn){btn.disabled=true;if(btnText)btnText.textContent='Bezig…';}
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){return r.json()})
          .then(function(){
            if(btnText)btnText.textContent='✓ Toegevoegd';
            document.dispatchEvent(new CustomEvent('cilsy:cart:added'));
            setTimeout(function(){
              if(btn){btn.disabled=false;if(btnText)btnText.textContent=btn.dataset.labelAdd||'Toevoegen aan tas';}
              if(window.location.pathname!=='/cart'){
                var d=document.querySelector('cart-drawer,#cart-drawer,[data-cart-drawer]');
                if(!d) window.location.href='/cart';
              }
            },1200);
          })
          .catch(function(){if(btn){btn.disabled=false;if(btnText)btnText.textContent='Probeer opnieuw'}});
      });
    }

    /* Accordion */
    root.querySelectorAll('[data-cyp-acc]').forEach(function(item){
      item.querySelector('.cyp-acc__btn').addEventListener('click',function(){
        item.classList.toggle('is-open');
      });
    });
  }
})();
